import { render, staticRenderFns } from "./vuezhongjian.vue?vue&type=template&id=220c8f49&scoped=true"
import script from "./vuezhongjian.vue?vue&type=script&lang=js"
export * from "./vuezhongjian.vue?vue&type=script&lang=js"
import style0 from "./vuezhongjian.vue?vue&type=style&index=0&id=220c8f49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220c8f49",
  null
  
)

export default component.exports